import React from 'react';
import { getIntl } from '../../utils/intl';
import * as Linking from 'expo-linking';
import { faqUrl, helpCenterUrl } from '../../utils/constants';
import Button from '../v2BaseComponents/Button';
import Stack from '../v2BaseComponents/Stack';
import Text from '../v2BaseComponents/Text';
import { getSpacing } from '../../utils/spacing';
import { useIsSocialAuthDisabled } from '../../hooks/useUrlAppParams';
import { useFederatedAuth } from '../../hooks/useFederatedAuth';
import { View } from 'react-native';
import Link from '../v2BaseComponents/Link';

const intl = getIntl('SharedLoginSection', {
    or: '- or -',
    question: 'Have a Question?',
    faq: 'FAQs',
    helpCenter: 'Help Center',
    createAccountConfirmation: 'By clicking Create Account, you agree to our Terms of Service and Privacy Policy.',
    redirectToProfessionalApp: 'Looking for the Professional Edition?',
});

export type SharedLoginSectionOwnProps = {
    isCreateAccount?: boolean;
};

export type SharedLoginSectionProps = SharedLoginSectionOwnProps;

const SharedLoginSection: React.FC<SharedLoginSectionProps> = (props) => {
    const federatedAuth = useFederatedAuth();
    const isSocialAuthDisabled = useIsSocialAuthDisabled();
    return (
        <Stack
            space={getSpacing(0.5)}
            align="center"
            justify="center"
            fullWidth
            style={{}}
            vertical
            testID="social-login-button-container"
        >
            {props.isCreateAccount ? (
                <Text variant="inactive-tab" alignText="center">
                    {intl('createAccountConfirmation')}
                </Text>
            ) : null}
            {isSocialAuthDisabled ? null : (
                <>
                    <Stack
                        justify="center"
                        horizontal
                        style={{
                            paddingBottom: getSpacing(6),
                        }}
                    >
                        <Text variant="input-field">{intl('or')}</Text>
                    </Stack>
                    <Stack vertical fullWidth space={getSpacing(4)}>
                        <Button
                            variant="secondary"
                            onPress={() => {
                                federatedAuth.signInWithRedirect('Apple');
                            }}
                            socialLogin="apple"
                            displayText
                            width="100%"
                            size="lg"
                            testID="apple-login-button"
                        />
                        <Button
                            variant="secondary"
                            onPress={() => {
                                federatedAuth.signInWithRedirect('Google');
                            }}
                            socialLogin="google"
                            displayText
                            width="100%"
                            size="lg"
                            testID="google-login-button"
                        />
                    </Stack>
                </>
            )}
            <Stack
                vertical
                fullWidth
                justify="center"
                align="center"
                style={{
                    paddingTop: getSpacing(20),
                    paddingBottom: getSpacing(4),
                }}
                space={getSpacing(4)}
            >
                <Text variant="h3" alignText="center">
                    {intl('question')}
                </Text>
                <View
                    style={{
                        alignSelf: 'stretch',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                    }}
                >
                    <Link
                        onPress={() => {
                            Linking.openURL(faqUrl);
                        }}
                        variant="body-1"
                        alignText="center"
                        style={{ width: 100 }}
                    >
                        {intl('faq')}
                    </Link>
                    <Link
                        onPress={() => {
                            Linking.openURL(helpCenterUrl);
                        }}
                        variant="body-1"
                        alignText="center"
                        style={{ width: 100 }}
                    >
                        {intl('helpCenter')}
                    </Link>
                </View>
            </Stack>
        </Stack>
    );
};

export default React.memo(SharedLoginSection);
